import { render, staticRenderFns } from "./MainMenuUserManual.vue?vue&type=template&id=80962f32"
import script from "./MainMenuUserManual.vue?vue&type=script&lang=js"
export * from "./MainMenuUserManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports